import {
  FETCH_POPULAR_PRODUCTS_FAILURE,
  FETCH_POPULAR_PRODUCTS_REQUEST,
  FETCH_POPULAR_PRODUCTS_SUCCESS,
} from "../types/popularProductsTypes";

const initialState = {
  loading: false,
  pop_products: [],
  error: null,
};

export default function popularProductsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_POPULAR_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_POPULAR_PRODUCTS_SUCCESS:
      // console.log("action.payload", action.payload);
      return {
        ...state,
        loading: false,
        pop_products: action.payload,
        error: null,
      };
    case FETCH_POPULAR_PRODUCTS_FAILURE:
      return { loading: false, pop_products: [], error: action.payload };
    default:
      return state;
  }
}
